<script type="text/jsx" lang="jsx">
import ConfigBase from '@/plans/EVENT_SAAS/config/base';
import BuyNowMixin from '@/plans/EVENT_SAAS/config/buy-now';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';

export default {
  mixins: [BuyNowMixin, planCommonMixin],
  components: {
    ConfigBase: {
      mixins: [ConfigBase, planCommonMixin],
    },
  },
};
</script>

